/**
 * The date a payment was collected, as a person reads it (#1916).
 *
 * Mark Paid used to store a picked date ("2026-10-14") as midnight UTC, which
 * is 7 PM the evening BEFORE in Texas — so every check showed a day early.
 * New saves store noon Central. Old rows are not rewritten, so a timestamp
 * that is exactly midnight UTC is read as the date that was picked.
 * Anything else is a real moment and is shown in local time.
 */
export function paidDateParts(v: string | Date | null | undefined): { date: Date; utc: boolean } | null {
    if (v === null || v === undefined || v === "") return null;
    const d = v instanceof Date ? v : new Date(v);
    if (Number.isNaN(d.getTime())) return null;
    const midnightUtc =
        d.getUTCHours() === 0 && d.getUTCMinutes() === 0 && d.getUTCSeconds() === 0 && d.getUTCMilliseconds() === 0;
    return { date: d, utc: midnightUtc };
}

export function formatPaidDate(v: string | Date | null | undefined): string {
    const p = paidDateParts(v);
    if (!p) return "—";
    return p.date.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
        ...(p.utc ? { timeZone: "UTC" } : {}),
    });
}
